import { useCallback } from 'react';
import { TValidationMethod } from 'js/utils/Validation/types';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { useGetFormFieldValue } from '../../../hooks';
import { useWithRecordLevelValidation } from './useWithRecordLevelValidation';

export const useSouthAfricanIdFieldValidation = ({ fieldName }: { fieldName: string }) => {
    const translate = useComponentTranslations();
    const getFormFieldValue = useGetFormFieldValue();
    const withRecordLevelValidation = useWithRecordLevelValidation({ fieldName });

    const validationSouthAfricanId = useCallback<TValidationMethod<string>>(async (value) => {
        const birthdate = getFormFieldValue('birthdate') || '';
        const [yyyy, mm, dd] = birthdate.split('-');
        const yy = yyyy.substring(2);
        const dateOfBirthPart = value.substring(0, 6);

        if (dateOfBirthPart !== `${yy}${mm}${dd}`) {
            return translate('playtech.mobile.system.form.southafricanid.internal.wrongDateOfBirth');
        }

        const actualSum = value.split('').reduceRight((sum, val, i, arr) => {
            const rightToLeftIndex = arr.length - i;
            const multiplier = rightToLeftIndex % 2 ? 1 : 2;
            const add = multiplier * Number(val);

            return sum + (add > 9 ? add - 9 : add);
        }, 0);

        if (actualSum % 10 !== 0) {
            return translate('playtech.mobile.system.form.southafricanid.internal.invalidId');
        }
    }, [getFormFieldValue, translate]);

    return withRecordLevelValidation(validationSouthAfricanId);
};
